import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 14,
	viewBox: "0 0 18 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.6 10.6L1.4 6.4L0 7.8L5.6 13.4L17.6 1.4L16.2 0L5.6 10.6Z",
		fill: "#09334B"
	})
});
export default SvgDone;
